import React from "react";

import RoomHeader from "../RoomHeader";
import Loginmask from "../../../misc/login/Loginmask";
import CustomCalendar from "./CustomCalendar";

import "./AllocationsStyle.css";

import { FaRegCalendarAlt } from "react-icons/fa";

const Allocations = ({ selectedRoom, loggedIn, loginSetter, allocations }) => {
  const loginComponent = () => {
    return (
      <div className="swiper-slide-section">
        <Loginmask loginSetter={loginSetter} rootId={2} />
      </div>
    );
  };

  const pageContent = () => {
    return (
      <div className="swiper-slide-section">
        <CustomCalendar eventList={allocations} />
      </div>
    );
  };

  return (
    <div className="allocations">
      <RoomHeader
        title="Belegungsplan"
        subtitle={selectedRoom.hoersaal}
        icon={<FaRegCalendarAlt className="section-indocator-icon" />}
      />

      {/* Login dependent content */}
      {loggedIn ? pageContent() : loginComponent()}
    </div>
  );
};

export default Allocations;
